import { dataSet } from "../main/data/data";
import { getHTML } from "../../utilities/getHTML";
import { getSongHistory } from "./getSongHistory";
export function getListOfSongs() {
    console.time("song-history");
    const key = "song-tracker-data";
    const now = new Date();
    const lastUpdated = Number(window.localStorage.getItem(key));
    const fullDayMS = 24 * 60 * 60 * 1000;
    return new Promise((resolve) => {
        // refresh once a day
        if (lastUpdated && lastUpdated + fullDayMS > now.valueOf()) {
            console.timeEnd("song-history");
            resolve(false);
            return;
        }
        getHTML("https://www.cedarparkchurchofchrist.org/members/song-tracker/leads")
            .then((html) => {
            const rows = html.querySelectorAll("tr");
            const waitForIt = [];
            const songs = [];
            const count = {
                total: rows.length,
                collected: 0,
            };
            for (let i = 0; i < rows.length; i++) {
                const cols = rows[i].querySelectorAll("td");
                if (cols.length) {
                    const splitTitle = cols[0].innerText.split(/\s{4,}/g);
                    const song = {
                        name: splitTitle[0].trim(),
                        book: splitTitle[1]
                            .trim()
                            .split(" - ")[1]
                            .replace(")", ""),
                        historyLink: cols[0].querySelector("a").href,
                        number: cols[1].innerText,
                        timesLead: Number(cols[2].innerText),
                    };
                    if (song.book.indexOf("Hymns for worship supplemental") > -1) {
                        song.id = 10 + song.number;
                    }
                    else if (song.book.indexOf("Misc New Songs") > -1) {
                        song.id = 50 + song.number;
                    }
                    else {
                        song.id = song.number;
                    }
                    songs.push(song);
                    waitForIt.push(getSongHistory(song, count));
                }
            }
            Promise.all(waitForIt).then((songs) => {
                const newStorage = {
                    lastUpdated: now.valueOf(),
                    songs: songs,
                };
                dataSet("song-history", newStorage); // set to firebase
                window.localStorage.setItem(key, String(now.valueOf()));
                console.timeEnd("song-history");
                resolve(newStorage);
            });
        })
            .catch((e) => console.warn(e));
    });
}
